import { useLocation } from "react-router-dom";

// This does not work on IE11.
export const useQueryParams = () => new URLSearchParams(useLocation().search);
